import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface ConnectedProps {
    startDate?: string;
}

type Props = ConnectedProps;

export class SharedEventStartDateHeader extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { startDate } = this.props;
        if (!startDate) return null;
        return (
            <Header sub className="shared-event-sub-header">
                Start Date
            </Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    startDate: makeSelectSharedEventValue('startDate')
});

export default connect(mapStateToProps)(SharedEventStartDateHeader);
